import React from "react";
import {withTranslation} from "react-i18next";
import stylesWelcome from "../SchedaSpecialeMalaria.module.css"
import Calendar from "../../../../../../../components/calendar/Calendar";
import Utils from "../../../../../../../utils/Utils";
import MalattieService from "../../../../../../../services/MalattieService";
import SelectAutocomplete from "../../../../../../../components/selectAutocomplete/SelectAutocomplete";
import SessioneUtente from "../../../../../../../sessionManager/SessioneUtente";
import Ruoli from "../../../../../../../utils/Ruoli.json";
import OggettiUtili from "../../../../../../../utils/OggettiUtili.json"


class EsitoMalaria extends React.Component {

    state = {
        esitoMalaria: {
            esito: "",
            dataDimissione: "",
            dataDecesso: ""
        },
        listaEsiti: []
    }

    constructor(props) {
        super(props)

        this.riceviValore = this.riceviValore.bind(this);
        this.createOggettoBE = this.createOggettoBE.bind(this)
        this.validate = this.validate.bind(this)

    }

    componentDidMount() {

        MalattieService.getEsiti(this.props.datiPaziente.malattia).then((data) => {
            let res = Utils.mapToArray(data.data);
            this.setState({listaEsiti: res})
        }).catch(() => {
            console.log("errore chiamata info cliniche")
        });

        let esitoMalaria = this.state.esitoMalaria
        let esitoMalariaProps = this.props.segnalazioneCopia && this.props.segnalazioneCopia.schedaSpeciale && this.props.segnalazioneCopia.schedaSpeciale.esitoMalaria ? this.props.segnalazioneCopia.schedaSpeciale.esitoMalaria : ""
        let esitoStep4Props = this.props.segnalazioneCopia.esito
        let datiSanitariProps = this.props.segnalazioneCopia.datiSanitari

        esitoMalaria.esito = esitoMalariaProps.esito ? esitoMalariaProps.esito : (esitoStep4Props.esito ? esitoStep4Props.esito : "")
        esitoMalaria.dataDimissione = esitoMalariaProps.dataDimissione ? esitoMalariaProps.dataDimissione : (datiSanitariProps.dataDimissione ? Utils.transformDateForFrontend(datiSanitariProps.dataDimissione) : "")
        esitoMalaria.dataDecesso = esitoMalariaProps.dataDecesso ? esitoMalariaProps.dataDecesso : (esitoStep4Props.dataDecesso ? Utils.transformDateForFrontend(esitoStep4Props.dataDecesso) : "")

        this.setState({esitoMalaria: esitoMalaria});
        let oggetto = this.createOggettoBE()
        this.props.setEsitoMalaria(this.state.esitoMalaria, "", oggetto);

    }

    componentDidUpdate(prevProps, prevState, snapshot) {
        if (prevState !== this.state) {
            let res = this.createOggettoBE()
            this.props.setEsitoMalaria(this.state.esitoMalaria, this.validate(), res)
        }
    }

    validate() {

        if (this.state.esitoMalaria.dataDecesso) {
            let validatedataDecesso = Utils.checkDateInterval(this.state.esitoMalaria.dataDecesso, "31/12/1899");
            let validatedataDecessoOdierna = Utils.checkDateInterval(this.state.esitoMalaria.dataDecesso, Utils.transformTimeStampForFrontend(Utils.getTodayDateTimestamp()));

            if (validatedataDecesso) {
                return "Messages.DataDecesso"
            } else if (!validatedataDecessoOdierna) {
                return "Messages.DataDecessoOdierna"
            }
        }
        if (this.state.esitoMalaria.dataDimissione) {
            let validatedataDimissione = Utils.checkDateInterval(this.state.esitoMalaria.dataDimissione, "31/12/1899");
            let validatedataDimissioneOdierna = Utils.checkDateInterval(this.state.esitoMalaria.dataDimissione, Utils.transformTimeStampForFrontend(Utils.getTodayDateTimestamp()));

            if (validatedataDimissione) {
                return "Messages.DataDimissioni"
            } else if (!validatedataDimissioneOdierna) {
                return "Messages.DataDimissioniOdierna"
            }
        }

        return ""

    }

    createOggettoBE() {
        let esitoMalaria = JSON.parse(JSON.stringify(this.state.esitoMalaria))
        let esitoMalariaBe = Utils.removeEmptyValueFromObject(esitoMalaria)
        return esitoMalariaBe;
    }

    riceviValore(field, event) {
        let esitoMalaria = this.state.esitoMalaria
        if (field.currentTarget) {
            esitoMalaria[field.currentTarget.id] = field.currentTarget.value
        } else {
            esitoMalaria[field] = event.target.value
        }
        this.setState({esitoMalaria: esitoMalaria})
    }

    render() {

        const {t} = this.props;

        const sezione1 = (
            <div>
                <div>
                    <h6>{t("SchedaFlussoSpeciale.Malaria.Esito.titolo")}</h6>
                    <hr className={stylesWelcome.hr}/>
                </div>
                <div style={{marginTop: "1rem"}}>
                    <div className="container">
                        <div className="row">
                            <div className="col-lg-6">
                                <div className="row">
                                    <div className="col-lg-1">
                                        <p style={{color: "#1b7ea9", marginTop: "10px"}}>
                                            {t("SchedaFlussoSpeciale.Malaria.Esito.esito")}
                                        </p>
                                    </div>
                                    <div className="col-lg-5">
                                        <SelectAutocomplete
                                            style={{width: "100%"}}
                                            field={"esito"}
                                            value={this.state.esitoMalaria.esito}
                                            onChange={this.riceviValore}
                                            disabled={(this.props.segnalazioneCopia && this.props.segnalazioneCopia.migrazione) || SessioneUtente.getInstance().ruoliUtente !== Ruoli.Operatore_Regionale.descrizione}
                                            id={"esito"}
                                            functionMap={this.state.listaEsiti.map((oggetto) => {
                                                return (
                                                    <option
                                                        value={oggetto.codiceEsito}>{oggetto.descrizioneEsito}</option>)
                                            })}
                                        >
                                        </SelectAutocomplete>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );

        const sezione2 = (

            <div style={{marginTop: "1rem"}}>
                <div className="container">
                    <div className="row">

                        <div className={`col-lg-3 ${this.props.segnalazioneCopia.statoValidazione === OggettiUtili.statoValidazioneByLabel.Validata.codice ? 'livello2' : ''}`}>
                            <p style={{color: "#1b7ea9", marginTop: "10px"}}>
                                {t("SchedaFlussoSpeciale.Malaria.Esito.dataDimissione")}
                            </p>
                            <Calendar
                                id={"dataDimissione"}
                                value={this.state.esitoMalaria.dataDimissione}
                                field={"dataDimissione"}
                                onChange={this.riceviValore}
                                errorMessage={Utils.replaceContentString(t("Messages.ERR_01_01_0B_0A"), "<nome campo>", t("SchedaFlussoSpeciale.Malaria.Esito.dataDimissione"))}
                                error={(this.state.esitoMalaria.dataDimissione === "" || this.state.esitoMalaria.dataDimissione == null) ? false :
                                    Utils.isDateInValid(Utils.transformDateForBackend(this.state.esitoMalaria.dataDimissione), "-")
                                }
                            >
                            </Calendar>
                        </div>

                        <div className={`col-lg-3 ${this.props.segnalazioneCopia.statoValidazione === OggettiUtili.statoValidazioneByLabel.Validata.codice ? 'livello1' : ''}`}>
                            <p style={{color: "#1b7ea9", marginTop: "10px"}}>
                                {t("SchedaFlussoSpeciale.Malaria.Esito.dataDecesso")}
                            </p>
                            <Calendar
                                id={"dataDecesso"}
                                value={this.state.esitoMalaria.dataDecesso}
                                field={"dataDecesso"}
                                onChange={this.riceviValore}
                                errorMessage={Utils.replaceContentString(t("Messages.ERR_01_01_0B_0A"), "<nome campo>", t("SchedaFlussoSpeciale.Malaria.Esito.dataDecesso"))}
                                error={(this.state.esitoMalaria.dataDecesso === "" || this.state.esitoMalaria.dataDecesso == null) ? false :
                                    Utils.isDateInValid(Utils.transformDateForBackend(this.state.esitoMalaria.dataDecesso), "-")
                                }
                            >
                            </Calendar>
                        </div>
                    </div>
                </div>
            </div>

        );


        return (
            <div>
                {sezione1}
                {sezione2}
            </div>

        )
    }

}

export default withTranslation('common')(EsitoMalaria)
